export function obtemDDD(telefoneCompleto: string): string {
  if (telefoneCompleto && telefoneCompleto.indexOf(")") > -1) {
    return telefoneCompleto.split(")")[0].replace(/\D/g, "");
  } else {
    return telefoneCompleto;
  }
}

export function obtemNumero(telefoneCompleto: string): string {
  if (telefoneCompleto && telefoneCompleto.indexOf(")") > -1) {
    return telefoneCompleto.split(")")[1].replace(/ /g, "");
  } else {
    return telefoneCompleto;
  }
}

